import React, {Component} from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import store from '../store';
import MessageBox2 from "./MessageBox2";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/user/UserAPI/`
})

const ReviewsApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/ReviewsAPI/`
})
const GigsApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/`
})
const Cartapi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/CartAPI/`
})
class Item extends Component{
    constructor(props) {
        super(props);
        this.state = {
          itemSeller:props.location.state.itemSeller,
          itemID:props.location.state.itemID,
          user:'',
          name:'',
          time:'No order completed yet',
          gig:[],
          reviews:[],
        }
        this.getGig();
        this.getSeller();
        this.getReviews();
        window.scrollTo(0, 0);
      }
    getGig = async () => {
        let data= await GigsApi.get(`GigApi/${this.state.itemID}/`);
        this.setState({gig:data.data})
        
        if (data.data.average_completionTime !== null) { 
            this.setState({time:this.secondsToDhms(data.data.average_completionTime)})
        }
        //console.log('data = ',data.data.average_completionTime)
    }
    getSeller = async () => {
        let data = await api.get(`/${this.state.itemSeller}/`).then(({data})=>data);
            this.setState({user:data[0].first_name + ' ' + data[0].last_name})
    }
    getReviews = async () => {
        let data = await ReviewsApi.get(`/${this.state.itemID}/`).then(({data})=>data);
        data.map(a =>
            this.getReviewGiverName(a,data)
            )     
    }
    getReviewGiverName= async (a,data) => {
        let data1 = await api.get(`/${a.buyer}/`).then(({data})=>data);
        a.buyer=data1[0].first_name + ' ' + data1[0].last_name
        this.setState({reviews:data}) 
    }
    addToCart = async() =>{
        let data = new FormData();
        data.append('buyer', store.getState().auth.user.id);
        data.append('seller',this.state.itemSeller );
        data.append('item',this.state.itemID );
        try {
            let res = await Cartapi.post('/',data);
            res?.status === 201 ? alert("Item is added to the Cart!") : alert("Can't Add to the cart.Try again later");
        }
        catch{
            alert("Can't place item to the cart!,try agin later");
        }
    }
    secondsToDhms = (seconds) => {
        seconds = Number(seconds);
        var d = Math.floor(seconds / (3600*24));
        var h = Math.floor(seconds % (3600*24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        //var s = Math.floor(seconds % 60);
        
        var dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
        var hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
        var mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes") : "";
        //var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        return dDisplay + hDisplay + mDisplay;
        //console.log(dDisplay + hDisplay + mDisplay)
        }
    
    render() {
        return(
        <>
            <br/><br/>
            <div className=' container w3-light-gray mt-5'>
                <div className='row pt-3 pb-3'>
                <div className='col'>
                <img src={this.state.gig.images} style={{height:'300px', width:'300px'}} alt="..." />
                </div>
                <div className='col col-lg-8'>
                <h3> {this.state.gig.title}</h3>
                <p style={{fontSize:'12px'}}>
                
                {this.props.location.state.itemRating.rating__avg !== null ?[ ...Array(5)].map((star, i) => {
                        const ratingValue = i+1;
                        const val= (this.props.location.state.itemRating - ratingValue)+1;
                        return(
                            <>
                            <label>
                            {(val > 0 && val<1) ? 
                                <i className='fa fa-star-half-full' style={{color:'#ffc107'}} />
                            :
                                <i className='fa fa-star' 
                                style={{ color:ratingValue <= ( this.props.location.state.itemRating ) ? '#ffc107' : '#D3D3D3'}} />
                            }
                            </label>
                            </>
                        );
                    }):'Not rated'}
                <br/> <b>Seller</b> : {this.state.user}
                <br/> <b>Completed Orders</b> : {this.state.gig.completed_orders}
                <br/><b>Average Order Completion Time </b> : {this.state.time}
                </p>
               
              

                <hr/>
                <h2 style={{color:'black'}}>Rs. {this.state.gig.price}</h2>
                {store.getState().auth.user ?
                    store.getState().auth.user.id === this.state.itemSeller ? <button type="button" className="btn btn-primary mt-4 me-4 ms-5" onClick={()=>alert('You Can not order your own product!')}><i className="fa fa-flash" ></i> Buy Now </button> :
                <Link style={{ textDecoration: 'none', color: 'inherit' }} to = {{pathname:'/order', 
                                state:{
                                    img:this.state.gig.images,
                                    title:this.state.gig.title,
                                    price:this.state.gig.price,
                                    seller:this.state.user,
                                    buyer:store.getState().auth.user.first_name + ' ' + store.getState().auth.user.last_name,
                                    buyerID:store.getState().auth.user.id,
                                    sellerID:this.state.itemSeller,
                                    itemID:this.state.itemID,
                                }
                            }}><button title='Order Item Now' type="button" className="btn btn-primary mt-4 me-4 ms-5"><i className="fa fa-lock" ></i> Buy Now </button></Link>
                            
                            :
                <Link to='/login'><button type="button" className="btn btn-primary mt-4 me-4 ms-5"><i className="fa fa-lock" ></i> Buy Now </button></Link>
                            }
                {store.getState().auth.user ?
                    <button title='Add Item to your Cart' type="button" className="btn btn-primary mt-4" onClick={()=>this.addToCart()}><i className='fa fa-cart-plus'></i> Add to Cart</button>
                :
                    <Link to='/login'><button title='Add Item to your Cart' type="button" className="btn btn-primary mt-4"><i className='fa fa-cart-plus'></i> Add to Cart</button></Link>
                }
                </div>
                </div>
            </div>

            <div className=' container w3-light-gray pb-2'>
                <h3 style={{  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}} className='pt-3' >Product Details </h3><hr/>
                <div dangerouslySetInnerHTML= {{__html: this.state.gig.details}} />
                
            </div>
           
            <div className=' container w3-light-gray mb-5 mt-3' style={{height:'400px', overflowY:'scroll'}}>
                <div><h3 className='pt-3' >Ratings & Reviews </h3><hr/></div>
                {this.state.reviews.map(a =>
                <div className='pe-5 ps-5'>
                <div className='row'>
                    <div className=' col col-lg-8'>
                    {[ ...Array(5)].map((star, i) => {
                        const ratingValue = i+1;
                        return(
                            <>
                            <label>
                                <i className='fa fa-star' 
                                style={{ color:ratingValue <= ( a.rating ) ? '#ffc107' : '#e4e5e9'}} />
                            </label>
                            </>
                        );
                    })}
                    <p style={{fontSize:'11px'}}><i className='fa fa-user'/> <span style={{color:'gray'}}>{a.buyer}</span></p>
                    </div>
                    <div className='col' style={{textAlign:'end', fontSize:'13px',color:'gray'}}>
                        {a.created_at.slice(0,10)}
                    </div>
                </div>
                <p className='ps-5 ms-5' style={{textAlign:'justify', fontSize:'13px'}}>{a.comment}</p>
                <hr style={{color:'violet'}} />
                </div>
                    )
                    }
                
            </div>
            
        </>
        )
     }
}
export default Item;